import { combineReducers } from '@reduxjs/toolkit';
import coreReducer from './core/coreSlice';
import userReducer from './user/userSlice';
import companiesReducer from './companies/companiesSlice';

const rootReducer = combineReducers({
  core: coreReducer,
  user: userReducer,
  companies: companiesReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
